import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { initialStateSlice } from "../../initialStateSlice";
import {
  // fetchAuthPost,
  reduceRepeatElement,
} from "../../../functions/functions";
import api from "../../../routes/api";
import { set_pdsp } from "../references/pdsp";
import { set_country } from "../references/country";
import { set_tour } from "../references/tour";
import {
  load_organizationSettings,
  set_organizationSettings,
  update_organizationSettings,
} from "../references/organizationSettings";
import { onCloseModalUploadLogo } from "../modal/modalUploadLogo";
import apis, { fetcher } from "../../../apis";

const formField = {
  organization: {
    id_organization: null,
    id_company: null,
    organization_name_thai: "",
    organization_name_english: "",
    address: "",
    id_country: null,
    id_province: null,
    id_district: null,
    id_subdistrict: null,
    postal_code: "",
    organization_logo: "",
    organization_logo_name: "",
    same_as_company_address: null,
  },
  company: {
    id_company: null,
    company_name_thai: "",
    company_name_english: "",
    address: "",
    branch_no: "",
    id_country: null,
    id_province: null,
    id_district: null,
    id_subdistrict: null,
    postal_code: "",
    phone_number: "",
    fax_number: "",
    tax_id: "",
    email: "",
    tour_operator_license: "",
    insurance_policy_number: "",
    insurance_company: "",
    head_office: null,
    adult_age: null,
    child_age: null,
    infant_age: null,
  },
  guest_setting: {
    adult_age: null,
    child_age: null,
    infant_age: null,
  },
};

const optionSelect = {
  countryOption: [],
  provinceOption: [],
  organizationDistrictOption: [],
  organizationSubdistrictOption: [],
  companyDistrictOption: [],
  companySubdistrictOption: [],
};

const formErrorMessage = {
  organization: {
    id_organization: null,
    id_company: null,
    organization_name_thai: null,
    organization_name_english: null,
    address: null,
    id_country: null,
    id_province: null,
    id_district: null,
    id_subdistrict: null,
    postal_code: null,
    organization_logo: null,
    organization_logo_name: null,
    same_as_company_address: null,
  },
  company: {
    id_company: null,
    company_name_thai: null,
    company_name_english: null,
    address: null,
    branch_no: null,
    id_country: null,
    id_province: null,
    id_district: null,
    id_subdistrict: null,
    postal_code: null,
    phone_number: null,
    fax_number: null,
    tax_id: null,
    email: null,
    tour_operator_license: null,
    insurance_policy_number: null,
    insurance_company: null,
    head_office: null,
    adult_age: null,
    child_age: null,
    infant_age: null,
  },
  guest_setting: {
    adult_age: null,
    child_age: null,
    infant_age: null,
  },
};

const formStatus = {
  isEdit: false,
};

const initialState = {
  ...initialStateSlice,
  body: { formField, optionSelect, formErrorMessage, formStatus },
};

const formOrganizationSettingsSlice = createSlice({
  name: "form/formOrganizationSettings",
  initialState,
  reducers: {
    onChangeLogo: (state, action) => {
      const imageSrc = action.payload.imageSrc;
      const imageName = action.payload.imageName;
      state.body.formField.organization.organization_logo = imageSrc;
      state.body.formField.organization.organization_logo_name = imageName;
    },
    onChangeOfOrganization: (state, action) => {
      const key = action.payload.key;
      const value = action.payload.value;
      state.body.formField.organization[key] = value;
      if (key === "same_as_company_address") {
        if (value) {
          state.body.formField.organization.address =
            state.body.formField.company.address;
          state.body.formField.organization.id_country =
            state.body.formField.company.id_country;
          state.body.formField.organization.id_province =
            state.body.formField.company.id_province;
          state.body.formField.organization.id_district =
            state.body.formField.company.id_district;
          state.body.formField.organization.id_subdistrict =
            state.body.formField.company.id_subdistrict;
          state.body.formField.organization.postal_code =
            state.body.formField.company.postal_code;

          state.body.optionSelect.organizationDistrictOption =
            state.body.optionSelect.companyDistrictOption;
          state.body.optionSelect.organizationSubdistrictOption =
            state.body.optionSelect.companySubdistrictOption;
        }
      }
    },
    onChangeOfCompany: (state, action) => {
      const key = action.payload.key;
      const value = action.payload.value;
      state.body.formField.company[key] = value;
      if (key === "head_office") {
        state.body.formField.company.head_office = value;
        if (value) {
          state.body.formField.company.branch_no = "000000";
        } else {
          state.body.formField.company.branch_no = "";
        }
      }
      if (state.body.formField.organization.same_as_company_address) {
        if (key === "address") {
          state.body.formField.organization.address = value;
        }
        if (key === "postal_code") {
          state.body.formField.organization.postal_code = value;
        }
      }
    },
    onChangeOfGuestSetting: (state, action) => {
      const key = action.payload.key;
      const value = action.payload.value;
      state.body.formField.guest_setting[key] = value;
    },
    onClickEditFormOrganizationSettings: (state) => {
      state.body.formStatus.isEdit = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initialSetupFormOrganizationSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        initialSetupFormOrganizationSettings.fulfilled,
        (state, action) => {
          state.loading = false;
          state.body.formField = action.payload.formField;
          state.body.optionSelect = action.payload.optionSelect;
          state.body.formErrorMessage = formErrorMessage;
          state.body.formStatus = formStatus;
        }
      )
      .addCase(
        initialSetupFormOrganizationSettings.rejected,
        (state, action) => {
          state.loading = true;
          state.error = action.error;
          console.error(action.error);
        }
      )
      .addCase(onChangeSelectProvinceOrganization.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        onChangeSelectProvinceOrganization.fulfilled,
        (state, action) => {
          state.loading = false;
          state.body.formField.organization.id_province =
            action.payload.id_province;
          state.body.formField.organization.id_district = null;
          state.body.formField.organization.id_subdistrict = null;
          state.body.formField.organization.postal_code = "";

          state.body.optionSelect.organizationDistrictOption =
            action.payload.organizationDistrictOption;
          state.body.optionSelect.organizationSubdistrictOption = [];
        }
      )
      .addCase(onChangeSelectProvinceOrganization.rejected, (state, action) => {
        state.loading = true;
        state.error = action.error;
        console.error(action.error);
      })
      .addCase(onChangeSelectDistrictOrganization.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        onChangeSelectDistrictOrganization.fulfilled,
        (state, action) => {
          state.loading = false;
          state.body.formField.organization.id_district =
            action.payload.id_district;
          state.body.formField.organization.id_subdistrict = null;
          state.body.formField.organization.postal_code = "";

          state.body.optionSelect.organizationSubdistrictOption =
            action.payload.organizationSubdistrictOption;
        }
      )
      .addCase(onChangeSelectDistrictOrganization.rejected, (state, action) => {
        state.loading = true;
        state.error = action.error;
        console.error(action.error);
      })
      .addCase(onChangeSelectSubdistrictOrganization.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        onChangeSelectSubdistrictOrganization.fulfilled,
        (state, action) => {
          state.loading = false;
          state.body.formField.organization.id_subdistrict =
            action.payload.id_subdistrict;
          state.body.formField.organization.postal_code =
            action.payload.postal_code;
        }
      )
      .addCase(
        onChangeSelectSubdistrictOrganization.rejected,
        (state, action) => {
          state.loading = true;
          state.error = action.error;
          console.error(action.error);
        }
      )
      .addCase(onChangeSelectProvinceCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(onChangeSelectProvinceCompany.fulfilled, (state, action) => {
        state.loading = false;
        const id_province = action.payload.id_province;
        const companyDistrictOption = action.payload.companyDistrictOption;
        state.body.formField.company.id_province = id_province;
        state.body.formField.company.id_district = null;
        state.body.formField.company.id_subdistrict = null;
        state.body.formField.company.postal_code = "";

        state.body.optionSelect.companyDistrictOption = companyDistrictOption;
        state.body.optionSelect.companySubdistrictOption = [];

        if (state.body.formField.organization.same_as_company_address) {
          state.body.formField.organization.id_province =
            state.body.formField.company.id_province;
          state.body.formField.organization.id_district =
            state.body.formField.company.id_district;
          state.body.formField.organization.id_subdistrict =
            state.body.formField.company.id_subdistrict;
          state.body.formField.organization.postal_code =
            state.body.formField.company.postal_code;

          state.body.optionSelect.organizationDistrictOption =
            state.body.optionSelect.companyDistrictOption;
          state.body.optionSelect.organizationSubdistrictOption =
            state.body.optionSelect.companySubdistrictOption;
        }
      })
      .addCase(onChangeSelectProvinceCompany.rejected, (state, action) => {
        state.loading = true;
        state.error = action.error;
        console.error(action.error);
      })
      .addCase(onChangeSelectDistrictCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(onChangeSelectDistrictCompany.fulfilled, (state, action) => {
        state.loading = false;
        const id_district = action.payload.id_district;
        const companySubdistrictOption =
          action.payload.companySubdistrictOption;
        state.body.formField.company.id_district = id_district;
        state.body.formField.company.id_subdistrict = null;
        state.body.formField.company.postal_code = "";

        state.body.optionSelect.companySubdistrictOption =
          companySubdistrictOption;

        if (state.body.formField.organization.same_as_company_address) {
          state.body.formField.organization.id_district =
            state.body.formField.company.id_district;
          state.body.formField.organization.id_subdistrict =
            state.body.formField.company.id_subdistrict;
          state.body.formField.organization.postal_code =
            state.body.formField.company.postal_code;

          state.body.optionSelect.organizationSubdistrictOption =
            state.body.optionSelect.companySubdistrictOption;
        }
      })
      .addCase(onChangeSelectDistrictCompany.rejected, (state, action) => {
        state.loading = true;
        state.error = action.error;
        console.error(action.error);
      })
      .addCase(onChangeSelectSubdistrictCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(onChangeSelectSubdistrictCompany.fulfilled, (state, action) => {
        state.loading = false;
        const id_subdistrict = action.payload.id_subdistrict;
        const postal_code = action.payload.postal_code;
        state.body.formField.company.id_subdistrict = id_subdistrict;
        state.body.formField.company.postal_code = postal_code;

        if (state.body.formField.organization.same_as_company_address) {
          state.body.formField.organization.id_subdistrict =
            state.body.formField.company.id_subdistrict;
          state.body.formField.organization.postal_code =
            state.body.formField.company.postal_code;
        }
      })
      .addCase(onChangeSelectSubdistrictCompany.rejected, (state, action) => {
        state.loading = true;
        state.error = action.error;
        console.error(action.error);
      })
      .addCase(onSaveFormOrganizationSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(onSaveFormOrganizationSettings.fulfilled, (state, action) => {
        state.loading = false;
        const hasInvalid = action.payload?.hasInvalid;
        if (hasInvalid) {
          const formErrorMessage = action.payload.formErrorMessage;
          state.body.formErrorMessage = formErrorMessage;
        } else {
          state.body.formStatus.isEdit = false;
        }
      })
      .addCase(onSaveFormOrganizationSettings.rejected, (state, action) => {
        state.loading = true;
        state.error = action.error;
        console.error(action.error);
      });
  },
});

export const {
  onChangeOfOrganization,
  onChangeOfCompany,
  onChangeOfGuestSetting,
  onChangeLogo,
  onClickEditFormOrganizationSettings,
} = formOrganizationSettingsSlice.actions;

export default formOrganizationSettingsSlice;

export const initialSetupFormOrganizationSettings = createAsyncThunk(
  "form/formOrganizationSettings/initialSetup",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    console.log(state.auth)
    let orgData = state.organizationSettings.body;
    if (!orgData) {
      // const resOrg = await fetchAuthPost(api.setting.readOrganization);
      // orgData = resOrg.data;
      const resOrg = await fetcher({
        route: "/organizationSettings/organization",
      });
      orgData = resOrg.json.data;
      dispatch(
        set_organizationSettings({ ...initialStateSlice, body: orgData })
      );
    }

    const {
      organization: {
        id_organization: organization__id_organization,
        id_company: organization__id_company,
        organization_name_thai: organization__organization_name_thai,
        organization_name_english: organization__organization_name_english,
        address: organization__address,
        id_country: organization__id_country,
        id_province: organization__id_province,
        id_district: organization__id_district,
        id_subdistrict: organization__id_subdistrict,
        postal_code: organization__postal_code,
        organization_logo: organization__organization_logo,
        organization_logo_name: organization__organization_logo_name,
        same_as_company_address: organization__same_as_company_address,
      },
      company: {
        id_company: company__id_company,
        company_name_thai: company__company_name_thai,
        company_name_english: company__company_name_english,
        address: company__address,
        branch_no: company__branch_no,
        id_country: company__id_country,
        id_province: company__id_province,
        id_district: company__id_district,
        id_subdistrict: company__id_subdistrict,
        postal_code: company__postal_code,
        phone_number: company__phone_number,
        fax_number: company__fax_number,
        tax_id: company__tax_id,
        email: company__email,
        tour_operator_license: company__tour_operator_license,
        insurance_policy_number: company__insurance_policy_number,
        insurance_company: company__insurance_company,
        head_office: company__head_office,
        adult_age: company__adult_age,
        child_age: company__child_age,
        infant_age: company__infant_age,
      },
      guest_setting: {
        adult_age: guest_setting__adult_age,
        child_age: guest_setting__child_age,
        infant_age: guest_setting__infant_age,
      },
    } = orgData;

    const formField = {
      organization: {
        id_organization: organization__id_organization,
        id_company: organization__id_company,
        organization_name_thai: organization__organization_name_thai,
        organization_name_english: organization__organization_name_english,
        address: organization__address,
        id_country: organization__id_country,
        id_province: organization__id_province,
        id_district: organization__id_district,
        id_subdistrict: organization__id_subdistrict,
        postal_code: organization__postal_code,
        organization_logo: organization__organization_logo,
        organization_logo_name: organization__organization_logo_name,
        same_as_company_address: organization__same_as_company_address,
      },
      company: {
        id_company: company__id_company,
        company_name_thai: company__company_name_thai,
        company_name_english: company__company_name_english,
        address: company__address,
        branch_no: company__branch_no,
        id_country: company__id_country,
        id_province: company__id_province,
        id_district: company__id_district,
        id_subdistrict: company__id_subdistrict,
        postal_code: company__postal_code,
        phone_number: company__phone_number,
        fax_number: company__fax_number,
        tax_id: company__tax_id,
        email: company__email,
        tour_operator_license: company__tour_operator_license,
        insurance_policy_number: company__insurance_policy_number,
        insurance_company: company__insurance_company,
        head_office: company__head_office,
        adult_age: company__adult_age,
        child_age: company__child_age,
        infant_age: company__infant_age,
      },
      guest_setting: {
        adult_age: guest_setting__adult_age,
        child_age: guest_setting__child_age,
        infant_age: guest_setting__infant_age,
      },
    };

    let countryOption = state.country.body;
    if (!countryOption) {
      // let countryData = await fetchAuthPost(api.address.readCountryList);
      // countryData = countryData.data;
      let countryData = await fetcher({ route: "/address/country" });
      countryData = countryData.json.data;
      dispatch(set_country({ ...initialStateSlice, body: countryData }));
      countryOption = countryData;
    }
    countryOption = countryOption.map((el) => ({
      value: +el.id_country,
      label: el.label_en,
    }));

    let allAddress = state.pdsp.body;
    if (!allAddress) {
      // let pdspData = await fetchAuthPost(
      //   api.address.readAllProvinceDistrictSubdistrict
      // );
      // pdspData = pdspData.data;
      let pdspData = await fetcher({
        route: "/address/allProvinceDistrictSubdistrict",
      });
      pdspData = pdspData.json.data;
      dispatch(set_pdsp({ ...initialStateSlice, body: pdspData }));
      allAddress = pdspData;
    }
    const provinceOption = reduceRepeatElement(allAddress, "id_province").map(
      (el) => ({
        value: +el.id_province,
        label: el.label_en_province,
      })
    );

    let organizationDistrictOption = [];
    organizationDistrictOption = allAddress.filter(
      (el) => +el.id_province === +organization__id_province
    );
    organizationDistrictOption = reduceRepeatElement(
      organizationDistrictOption,
      "id_district"
    ).map((el) => ({ value: +el.id_district, label: el.label_en_district }));

    let organizationSubdistrictOption = [];
    organizationSubdistrictOption = allAddress.filter(
      (el) => +el.id_district === +organization__id_district
    );
    organizationSubdistrictOption = reduceRepeatElement(
      organizationSubdistrictOption,
      "id_subdistrict"
    ).map((el) => ({
      value: +el.id_subdistrict,
      label: el.label_en_subdistrict,
    }));

    let companyDistrictOption = [];
    companyDistrictOption = allAddress.filter(
      (el) => +el.id_province === +company__id_province
    );
    companyDistrictOption = reduceRepeatElement(
      companyDistrictOption,
      "id_district"
    ).map((el) => ({ value: +el.id_district, label: el.label_en_district }));

    let companySubdistrictOption = [];
    companySubdistrictOption = allAddress.filter(
      (el) => +el.id_district === +company__id_district
    );
    companySubdistrictOption = reduceRepeatElement(
      companySubdistrictOption,
      "id_subdistrict"
    ).map((el) => ({
      value: +el.id_subdistrict,
      label: el.label_en_subdistrict,
    }));

    const optionSelect = {
      countryOption,
      provinceOption,
      organizationDistrictOption,
      organizationSubdistrictOption,
      companyDistrictOption,
      companySubdistrictOption,
    };

    const body = { formField, optionSelect };
    return body;
  }
);

export const onChangeSelectProvinceOrganization = createAsyncThunk(
  "form/formOrganizationSettings/changeSelectProvinceOrganization",
  async (payload, { getState }) => {
    const state = getState();
    const allAddress = state.pdsp.body;
    const id_province = payload.id_province;

    let organizationDistrictOption = [];
    organizationDistrictOption = allAddress.filter(
      (el) => +el.id_province === +id_province
    );
    organizationDistrictOption = reduceRepeatElement(
      organizationDistrictOption,
      "id_district"
    ).map((el) => ({ value: +el.id_district, label: el.label_en_district }));

    const result = { id_province, organizationDistrictOption };
    return result;
  }
);

export const onChangeSelectDistrictOrganization = createAsyncThunk(
  "form/formOrganizationSettings/changeSelectDistrictOrganization",
  async (payload, { getState }) => {
    const state = getState();
    const allAddress = state.pdsp.body;
    const id_district = payload.id_district;

    let organizationSubdistrictOption = [];
    organizationSubdistrictOption = allAddress.filter(
      (el) => +el.id_district === +id_district
    );
    organizationSubdistrictOption = reduceRepeatElement(
      organizationSubdistrictOption,
      "id_subdistrict"
    ).map((el) => ({
      value: +el.id_subdistrict,
      label: el.label_en_subdistrict,
    }));

    const result = { id_district, organizationSubdistrictOption };
    return result;
  }
);

export const onChangeSelectSubdistrictOrganization = createAsyncThunk(
  "form/formOrganizationSettings/changeSelectSubdistrictOrganization",
  async (payload, { getState }) => {
    const state = getState();
    const allAddress = state.pdsp.body;
    const id_subdistrict = +payload.id_subdistrict;

    let postal_code = allAddress.find(
      (el) => +el.id_subdistrict === id_subdistrict
    );
    postal_code = postal_code.postal_code;

    const result = { id_subdistrict, postal_code };
    return result;
  }
);

export const onChangeSelectProvinceCompany = createAsyncThunk(
  "form/formOrganizationSettings/changeSelectProvinceCompany",
  async (payload, { getState }) => {
    const state = getState();
    const allAddress = state.pdsp.body;
    const id_province = payload.id_province;

    let companyDistrictOption = [];
    companyDistrictOption = allAddress.filter(
      (el) => +el.id_province === +id_province
    );
    companyDistrictOption = reduceRepeatElement(
      companyDistrictOption,
      "id_district"
    ).map((el) => ({ value: +el.id_district, label: el.label_en_district }));

    const result = { id_province, companyDistrictOption };
    return result;
  }
);

export const onChangeSelectDistrictCompany = createAsyncThunk(
  "form/formOrganizationSettings/changeSelectDistrictCompany",
  async (payload, { getState }) => {
    const state = getState();
    const allAddress = state.pdsp.body;
    const id_district = payload.id_district;

    let companySubdistrictOption = [];
    companySubdistrictOption = allAddress.filter(
      (el) => +el.id_district === +id_district
    );
    companySubdistrictOption = reduceRepeatElement(
      companySubdistrictOption,
      "id_subdistrict"
    ).map((el) => ({
      value: +el.id_subdistrict,
      label: el.label_en_subdistrict,
    }));

    const result = { id_district, companySubdistrictOption };
    return result;
  }
);

export const onChangeSelectSubdistrictCompany = createAsyncThunk(
  "form/formOrganizationSettings/changeSelectSubdistrictCompany",
  async (payload, { getState }) => {
    const state = getState();
    const allAddress = state.pdsp.body;
    const id_subdistrict = +payload.id_subdistrict;

    let postal_code = allAddress.find(
      (el) => +el.id_subdistrict === id_subdistrict
    );
    postal_code = postal_code.postal_code;

    const result = { id_subdistrict, postal_code };
    return result;
  }
);

export const onCancelFormOrganizationSettings = createAsyncThunk(
  "form/formOrganizationSettings/cancel",
  async (payload, { getState, dispatch, extra }) => {
    await dispatch(initialSetupFormOrganizationSettings()).unwrap();
    extra.navigate("/welcome");
  }
);

export const onSaveFormOrganizationSettings = createAsyncThunk(
  "form/formOrganizationSettings/save",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const formOrganizationSettingsState = state.formOrganizationSettings;
    const formField = formOrganizationSettingsState.body.formField;
    const formErrorMessage = JSON.parse(
      JSON.stringify(formOrganizationSettingsState.body.formErrorMessage)
    );

    const hasInvalid = !(
      formField.organization.organization_name_thai &&
      formField.organization.address &&
      formField.organization.id_country &&
      formField.organization.id_province &&
      formField.organization.id_district &&
      formField.organization.id_subdistrict &&
      formField.organization.postal_code &&
      formField.organization.organization_logo &&
      formField.company.company_name_thai &&
      formField.company.address &&
      formField.company.branch_no &&
      formField.company.id_country &&
      formField.company.id_province &&
      formField.company.id_district &&
      formField.company.id_subdistrict &&
      formField.company.postal_code &&
      formField.company.phone_number &&
      formField.company.fax_number &&
      formField.guest_setting.adult_age &&
      formField.guest_setting.child_age &&
      formField.guest_setting.infant_age
    );
    // field validate
    if (!formField.organization.id_organization) {
      formErrorMessage.organization.id_organization = null;
    }
    if (!formField.organization.id_company) {
      formErrorMessage.organization.id_company = null;
    }
    if (!formField.organization.organization_name_thai) {
      formErrorMessage.organization.organization_name_thai = 1;
    }
    if (!formField.organization.organization_name_english) {
      formErrorMessage.organization.organization_name_english = null;
    }
    if (!formField.organization.address) {
      formErrorMessage.organization.address = 1;
    }
    if (!formField.organization.id_country) {
      formErrorMessage.organization.id_country = 1;
    }
    if (!formField.organization.id_province) {
      formErrorMessage.organization.id_province = 1;
    }
    if (!formField.organization.id_district) {
      formErrorMessage.organization.id_district = 1;
    }
    if (!formField.organization.id_subdistrict) {
      formErrorMessage.organization.id_subdistrict = 1;
    }
    if (!formField.organization.postal_code) {
      formErrorMessage.organization.postal_code = 1;
    }
    if (!formField.organization.organization_logo) {
      formErrorMessage.organization.organization_logo = 1;
    }
    if (!formField.organization.organization_logo_name) {
      formErrorMessage.organization.organization_logo_name = null;
    }
    if (!formField.organization.same_as_company_address) {
      formErrorMessage.organization.same_as_company_address = null;
    }

    if (!formField.company.id_company) {
      formErrorMessage.company.id_company = null;
    }
    if (!formField.company.company_name_thai) {
      formErrorMessage.company.company_name_thai = 1;
    }
    if (!formField.company.company_name_english) {
      formErrorMessage.company.company_name_english = null;
    }
    if (!formField.company.address) {
      formErrorMessage.company.address = 1;
    }
    if (!formField.company.branch_no) {
      formErrorMessage.company.branch_no = 1;
    }
    if (!formField.company.id_country) {
      formErrorMessage.company.id_country = 1;
    }
    if (!formField.company.id_province) {
      formErrorMessage.company.id_province = 1;
    }
    if (!formField.company.id_district) {
      formErrorMessage.company.id_district = 1;
    }
    if (!formField.company.id_subdistrict) {
      formErrorMessage.company.id_subdistrict = 1;
    }
    if (!formField.company.postal_code) {
      formErrorMessage.company.postal_code = 1;
    }
    if (!formField.company.phone_number) {
      formErrorMessage.company.phone_number = 1;
    }
    if (!formField.company.fax_number) {
      formErrorMessage.company.fax_number = 1;
    }
    if (!formField.company.tax_id) {
      formErrorMessage.company.tax_id = null;
    }
    if (!formField.company.email) {
      formErrorMessage.company.email = null;
    }
    if (!formField.company.tour_operator_license) {
      formErrorMessage.company.tour_operator_license = null;
    }
    if (!formField.company.insurance_policy_number) {
      formErrorMessage.company.insurance_policy_number = null;
    }
    if (!formField.company.insurance_company) {
      formErrorMessage.company.insurance_company = null;
    }
    if (!formField.company.head_office) {
      formErrorMessage.company.head_office = null;
    }
    if (!formField.company.adult_age) {
      formErrorMessage.company.adult_age = null;
    }
    if (!formField.company.child_age) {
      formErrorMessage.company.child_age = null;
    }
    if (!formField.company.infant_age) {
      formErrorMessage.company.infant_age = null;
    }

    if (!formField.guest_setting.adult_age) {
      formErrorMessage.guest_setting.adult_age = 1;
    }
    if (!formField.guest_setting.child_age) {
      formErrorMessage.guest_setting.child_age = 1;
    }
    if (!formField.guest_setting.infant_age) {
      formErrorMessage.guest_setting.infant_age = 1;
    }

    if (hasInvalid) {
      return { hasInvalid, formErrorMessage };
    } else {
      const apiPayload = {
        data: {
          organization: formField.organization,
          company: formField.company,
          guest_setting: formField.guest_setting,
        },
      };

      await dispatch(update_organizationSettings(apiPayload)).unwrap();
      await dispatch(initialSetupFormOrganizationSettings()).unwrap();
    }
  }
);

export const onSubmitLogo = createAsyncThunk(
  "form/formOrganizationSettings/submitLogo",
  async (payload, { getState, dispatch }) => {
    const srcLogo = payload;
    const state = getState();
    const formField = state.formOrganizationSettings.body.formField;
    let imageSrc;
    let imageName;
    imageSrc = srcLogo?.src;
    if (
      Boolean(srcLogo?.src) === true &&
      Boolean(srcLogo?.name) === false &&
      Boolean(formField.organization.organization_logo_name) === true
    ) {
      imageName = formField.organization.organization_logo_name || "";
    } else if (Boolean(srcLogo?.src) === false) {
      imageName = "";
    } else if (
      Boolean(srcLogo?.src) === true &&
      Boolean(srcLogo?.name) === true
    ) {
      imageName = srcLogo?.name || "";
    }
    dispatch(onChangeLogo({ imageName, imageSrc }));
    if (imageSrc) {
      dispatch(onCloseModalUploadLogo());
    }
  }
);
